const CurvedLine2 = () => {
  return (
    <svg viewBox="0 0 1143 1305" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.05"
        d="M3.02604 2.43777C210.069 105.972 293.14 344.96 162.342 418.339C31.5441 491.718 -124.081 715.765 171.199 968.051C424.931 1184.84 245.501 1344.95 148.637 1244.15C46.074 1137.42 107.221 1074.5 234.304 1128.19C379.584 1189.58 570.135 1390.19 756.442 1258.12C928.646 1136.04 1049.98 1200.07 1140.5 1277.95"
        stroke="#182911"
        strokeWidth="4.65549"
      />
    </svg>
  );
};

export default CurvedLine2;
